module.exports = __webpack_public_path__ + "img/help_authentication_y@3x.e6d37261.png";